import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { ProjectTask_Entity } from "../../entities/projectTask";
import { filmsApi } from "../api/filmsApi";

const projectTasksAdapter = createEntityAdapter<ProjectTask_Entity>();
const initialState = projectTasksAdapter.getInitialState();

export const projectTaskEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getProjectTasks: build.query<
      EntityState<ProjectTask_Entity>,
      number | undefined
    >({
      query: (projectID) => ({
        url: `projects/${projectID}/tasks`,
      }),
      transformResponse: (responseData: ProjectTask_Entity[]) => {
        return projectTasksAdapter.setAll(initialState, responseData);
      },
      providesTags: ["projectTasks"],
    }),
    getProjectTask: build.query<ProjectTask_Entity, number>({
      query: (id) => `projectTasks/${id}`,
      providesTags: (result, error, id) => [{ type: "projectTasks", id }],
    }),
    createProjectTask: build.mutation<
      ProjectTask_Entity,
      Partial<ProjectTask_Entity>
    >({
      query: (body) => ({
        method: "POST",
        body,
        url: `projectTasks`,
      }),
      invalidatesTags: ["projectTasks", "projects", "budgets"],
    }),
    updateProjectTask: build.mutation<
      void,
      { id: number; body: Partial<ProjectTask_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `projectTasks/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "projectTasks", id },
        "projectTasks",

        "projects",
        "budgets",
      ],
    }),
    deleteProjectTask: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `projectTasks/${id}`,
      }),
      invalidatesTags: ["projectTasks", "projects", "budgets"],
    }),
  }),
});

export const {
  useGetProjectTaskQuery,
  useGetProjectTasksQuery,
  useCreateProjectTaskMutation,
  useDeleteProjectTaskMutation,
  useUpdateProjectTaskMutation,
} = projectTaskEndpoints;

export default projectTaskEndpoints;
